/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, NgZone, OnInit } from '@angular/core';

/**
 * Modal imports.
 */
import { SeeMore } from '../../../stories/interface/types';

@Component({
  selector: 'app-meta-generator',
  templateUrl: './meta-generator.component.html',
  styleUrls: ['./meta-generator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MetaGeneratorComponent implements OnInit {
  

  constructor(private zone: NgZone) {

  }

  /**
   * See more information
   */
  @Input() seeMore: SeeMore;

  /**
   * Emit generated meta.
   * Emit action on generated Meta.
   */
  @Output() emitOnMeta: EventEmitter<string> = new EventEmitter();

  @Output() clickedOutSide: EventEmitter<any> = new EventEmitter();

  /**
   * Status for the meta status.
   */
  @Input() isMetaState = false;
  @Input() deepLink: string;

  @Input() tagMeta: boolean;

  @Input() isTagMetaGenerated: boolean;

  @Input() viewPostText: string;

  /**
   * Action on generated Meta.
   */
  onMeta(): void {
    if (this.deepLink) {
      this.emitOnMeta.emit(this.deepLink);
    }
    else if (this.seeMore) {
      this.emitOnMeta.emit(this.seeMore.customId);
    }
  }

  ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      document.addEventListener('click', (event) => {
        this.zone.run(() => {

          this.clickedOutSide.emit(true);
        });
      });
    });
  }
}
